import { HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SECOND_MILLISECONDS } from '@senet-uiverse/common';
import { switchMap } from 'rxjs';

import { ProfileService, StorageService } from '../services';

const WHITE_LIST = [
  'auth/send-email-verification-code',
  'auth/fill-missing-keycloak-data',
  'auth/check-email-exists',
  'auth/check-phone-exists',
  'auth/verify-email-code',
];

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const storageService = inject(StorageService);
  const profileService = inject(ProfileService);

  const user = storageService.storage().user;

  // ? Виключаємо всі auth endpoints з обробки в interceptor
  if (req.url.includes('auth/') && !WHITE_LIST.some((endpoint) => req.url.includes(endpoint))) {
    return next(req);
  }

  if (user) {
    if (isTokenExpired(user.keycloak_access_token)) {
      return profileService.refreshToken().pipe(
        switchMap((response) => {
          return next(editHeaders(req, response.keycloak_access_token));
        }),
      );
    }

    return next(editHeaders(req, user.keycloak_access_token));
  }

  return next(req);
};

const editHeaders = (req: HttpRequest<unknown>, token: string) => {
  return req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });
};

const BUFFER_TIME = 300000;

const isTokenExpired = (token: Readonly<string>) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));

    const exp = payload.exp * SECOND_MILLISECONDS;

    const now = Date.now();

    return now >= exp - BUFFER_TIME;
  } catch {
    return true;
  }
};
